import { broadcast, broadcastChannels } from "@common/helpers/broadcast";

export const getTimestampToken = () => new Promise((resolve, reject) => {
  window.jsobject?.getTimestampToken();
  broadcast.addEventListener(broadcastChannels.RecieveTimestampToken,  (e) => resolve(e.detail), { once: true });
  setTimeout(() => reject(), 10000);
});